export default __webpack_public_path__ + "static/Story_Image_5_650x650px-6771abb48c2a3ff971e138b073f5f9b5.png";